import styled from "@emotion/styled";
import { Button, Typography } from "@mui/material";

export const AuthCardHeader = styled(Typography)(({ theme }: any) => ({
  fontFamily: "Inter",
  fontSize: "28px",
  fontWeight: 400,
  lineHeight: "34px",
  textAlign: "left",
  color: "#323232",
 
}));

export const AuthCardSubHeader = styled(Typography)(({ theme }: any) => ({
    fontFamily: "Inter",
    fontSize: "15px",
    fontWeight: 400,
    lineHeight: "22px",
    textAlign: "left",
    color: "#323232",
    // [theme.breakpoints.down("md")]: {
    //   fontSize: "28px",
    //   fontWeight: 400,
    //   lineHeight: "34px",
    // },
  }));
